const KEY_MARKET_NUMBER = 'market-number';
const KEY_PRE_CHECKOUT_OPTION_LIMIT = 'pre-checkout-option-limit';

export const setStoredMarketNumber = (company: number | null) => {
    if (company) {
        window.localStorage.setItem(KEY_MARKET_NUMBER, company.toString());
    } else {
        window.localStorage.removeItem(KEY_MARKET_NUMBER);
    }
};

export const getStoredMarketNumber = () => {
    const company = window.localStorage.getItem(KEY_MARKET_NUMBER);
    return company ? Number(company) : null;
};

export const getStoredPreCheckoutOptionLimit = (): string | null => {
    return window.localStorage.getItem(KEY_PRE_CHECKOUT_OPTION_LIMIT);
};
